import { Integration } from "../../../Everou/_modelsTS/Integration";

export class PMSIntegrationsHelper {

    static checkIfLinkExists(link: string, integrations: Integration[]) {
           return integrations.some(({link: integrationLink}) => link === integrationLink); 
    }

}